<template>
  <div class="cenum-setting">
    <div class="cenue-title">User-Agent {{ $t("product.shield") }}</div>
    <!--  -->

    <div class="lan-dong">
      <!-- <span class="text-gray-style">User-Agent</span> -->
      <CDNRadios
        v-model="UserAgentAction"
        :items="items1"
        :label="$t('product.Intercept')"
        :hasLine="false"
      />
      <!-- <div style="display: flex; aligin-item: center">
        <CDNCheckbox
          @selectedCheck="(e) => (matchUserAgnet1 = e)"
          :front="false"
          :checkedStatus="matchUserAgnet1"
          :label="$t('product.PreciseMatch')"
        />
        <CDNCheckbox
          @selectedCheck="(e) => (matchUserAgnet2 = e)"
          :front="false"
          :label="$t('product.FuzzyMatch')"
        />
      </div> -->
      <el-row :gutter="20">
      <el-col :span="12">
        <div class="text-gray-style tip-label">UserAgent {{ $t("product.FuzzyMatch") }}</div>
        <el-input
            type="textarea"
            :rows="3"
            :placeholder="$t('product.inputTip')"
            v-model="UserAgentText"
          >
        </el-input>        
      </el-col>
      <el-col :span="12">
        <div class="text-gray-style tip-label">UserAgent {{ $t("product.PreciseMatch") }}</div>
        <el-input
            type="textarea"
            :rows="3"
            :placeholder="$t('product.inputTip')"
            v-model="matchUserAgentText"
          >
        </el-input>        
      </el-col>
      </el-row>
      <!-- <div style="margin-top: 24px">
        <el-input
          type="textarea"
          :rows="5"
          :placeholder="$t('product.cacheTip')"
          v-model="UserAgentActionTextarea"
        >
        </el-input>
      </div> -->

      <CDNSwitch
        :label="$t('allDomain.ShieldEmptyUA')"
        :hasbottomline="false"
        @change="switchChange"
        :inValue="isBanEmptyUA == 1"
      />
    </div>
    <div class="btn-commit" @click="commitClick1">
      {{ $t("product.commit") }}
    </div>

    <div class="my-line"></div>

      <el-row :gutter="20">
      <el-col :span="12">
    <!-- IP白名单  -->

    <div class="cenue-title">{{ $t("allDomain.IPWhiteList") }}</div>
    <div style="margin-top: 24px">
      <div class="row-line">
        <loginInput
          :label="$t('allDomain.whitelistMask')"
          tipStyle="color: #A1A7C4;margin-left: -12px;"
          inputStyle="width: 300px;"
          realInputStyle="width: 300px; height: 40px;"
          :inputValue="ipWhiteListItem"
          @changeInput="(e) => (ipWhiteListItem = e)"
        />
        <div class="new-add" @click="addWhite">{{ $t("allDomain.add") }}</div>
      </div>
      <!-- 列表 -->
       <el-table
       :data="whiteTableData"
       style="width: 100%"
    >
        <el-table-column
          align="center"
          prop="IP"
          :label="`Ip/${$t('product.mark')}`"
        >
        </el-table-column>
        
        <el-table-column
          align="center"
          :label="$t('product.handle')"
        >
        <template slot-scope="scope">
            <div @click="delClick(scope.row, 'white')">
                {{ $t("allDomain.delete") }}
              </div>
        </template>
        </el-table-column>
         </el-table>
     
    </div>


      </el-col>
      <el-col :span="12">

    <!-- IP黑名单 -->

    <div class="cenue-title">{{ $t("allDomain.IPBlackList") }}</div>
    <div style="margin-top: 24px">
      <div class="row-line">
        <loginInput
          :label="$t('allDomain.blackListMark')"
          tipStyle="color: #A1A7C4;margin-left: -12px;"
          inputStyle="width: 300px;"
          realInputStyle="width: 300px; height: 40px;"
          :inputValue="ipBlackListItem"
          @changeInput="(e) => (ipBlackListItem = e)"
        />
        <div class="new-add" @click="addBlack">{{ $t("allDomain.add") }}</div>
      </div>
      <!-- 列表 -->
      <el-table
       :data="blackTableData"
       style="width: 100%"
    >
        <el-table-column
          align="center"
          prop="IP"
          :label="`Ip/${$t('product.mark')}`"
        >
        </el-table-column>
        
        <el-table-column
          align="center"
          :label="$t('product.handle')"
        >
        <template slot-scope="scope">
            <div @click="delClick(scope.row, 'black')">
                {{ $t("allDomain.delete") }}
              </div>
        </template>
        </el-table-column>
         </el-table>
    </div>

      </el-col>
      </el-row>

    <div class="my-line"></div>

      <el-row :gutter="20">
      <el-col :span="12">
    <!-- URL白名单 -->
    <div class="cenue-title">{{ $t("allDomain.URLWhiteList") }}</div>
    <div class="lan-dong">
      <span class="text-gray-style">{{ $t("allDomain.URLWhiteList") }}</span>

      <div style="margin-top: 24px">
        <el-input
          type="textarea"
          :rows="5"
          placeholder="/url"
          v-model="whiteurltextarea"
        >
        </el-input>
        <div style="margin-bottom: 15px; color: #666666; font-size: 14px">
          {{ $t("product.inputTip") }}
        </div>
      </div>

      <div class="btn-commit" @click="commiturlWhiteClick">
      {{ $t("product.commit") }}
    </div>
    
    </div>


      </el-col>
      <el-col :span="12">

    <!-- URL黑名单 -->

    <div class="cenue-title">{{ $t("allDomain.URLBlackList") }}</div>
    <div class="lan-dong">
      <span class="text-gray-style">{{ $t("allDomain.URLBlackList") }}</span>

      <div style="margin-top: 24px">
        <el-input
          type="textarea"
          :rows="5"
          placeholder="/url"
          v-model="IPBalcktextarea"
        >
        </el-input>
        <div style="margin-bottom: 15px; color: #666666; font-size: 14px">
          {{ $t("product.inputTip") }}
        </div>
      </div>

      <div class="btn-commit" @click="commiturlBlackClick">
      {{ $t("product.commit") }}
    </div>
    </div>


      </el-col>
      </el-row>


    <div class="my-line"></div>
    <!-- 区域屏蔽 -->
    <div class="cenue-title">{{ $t("allDomain.ShieldingArea") }}</div>
    <div class="lan-dong margin-top">
      <CDNSwitch
        :label="$t('allDomain.ShieldingArea')"
        :hasbottomline="false"
        :inValue="banArea"
        @change="(e) => (banArea = e)"
      />
    </div>
    <div v-if="banArea">
     <div class="checkout-rows">
        <CDNSwitch
        :label="$t('allDomain.checkedAll')"
        :hasbottomline="false"
        :inValue="banAll"
        isContol
        @change="(e) => checkedAllClick(e)"
      />
       <CDNSwitch
        :label="$t('allDomain.Asia')"
        :hasbottomline="false"
        :inValue="banAsia"
        isContol
        @change="(e) => checkedAsiaClick(e, 'Asia')"
      />
      
       <CDNSwitch
        :label="$t('allDomain.Europe')"
        :hasbottomline="false"
        :inValue="banEurope"
        isContol
        @change="(e) => checkedAsiaClick(e, 'Europe')"
      />
      
       <CDNSwitch
        :label="$t('allDomain.SouthAmeria')"
        :hasbottomline="false"
        :inValue="banSouthAmeria"
        isContol
        @change="(e) => checkedAsiaClick(e, 'South America')"
      />
      
       <CDNSwitch
        :label="$t('allDomain.NorthAmeria')"
        :hasbottomline="false"
        :inValue="banSouthAmeria"
        isContol
        @change="(e) => checkedAsiaClick(e, 'North America')"
      />
      
       <CDNSwitch
        :label="$t('allDomain.Africa')"
        :hasbottomline="false"
        :inValue="banAfrica"
        isContol
        @change="(e) => checkedAsiaClick(e, 'Africa')"
      />
      
      
       <CDNSwitch
        :label="$t('allDomain.Oceania')"
        :hasbottomline="false"
        :inValue="banOceania"
        isContol
        @change="(e) => checkedAsiaClick(e, 'Oceania')"
      />
     </div>
      <el-checkbox-group v-model="checkboxGroup1" size="mini">
        <!-- <el-checkbox-button v-for="(city, index) in countryList" :label="city.cname" :key="city.continent + index">{{city.cname}}</el-checkbox-button> -->
        <el-checkbox v-for="(city, index) in countryList" :label="city.cname" :key="city.continent + index">{{isEn_us ? city.name : city.cname}}</el-checkbox>
      </el-checkbox-group>
    </div>
    <!--  -->

      <div class="btn-commit" @click="commiturlArea">
      {{ $t("product.commit") }}
    </div>

    <div class="my-line"></div>
    <!-- jsGuard防御 -->
    <div class="cenue-title">{{ $t("allDomain.JsguardDefense") }}</div>
    <div class="lan-dong margin-top">
      <CDNSwitch
        ref="jsguard"
        :label="$t('allDomain.JsguardDefense')"
        :hasbottomline="false"
        :inValue="jsGuard"
        @change="jsGuardChange"
      />
    </div>
    <!--  -->


    <div class="my-line"></div>
    <!-- 验证码防御 -->
    <div class="cenue-title">{{ $t("allDomain.CaptchaDefense") }}</div>
    <div class="lan-dong margin-top">
      <CDNSwitch
        :label="$t('allDomain.CaptchaDefense')"
        :hasbottomline="false"
        :inValue="useCaptcha"        
        @change="useCaptchaChange"
      />
    </div>
    <!--  -->


    <div class="my-line"></div>
    <!-- 触发防御频率 -->
    <div class="cenue-title">
      {{ $t("allDomain.TriggerDefenseFrequency") }}
    </div>
    <div class="lan-dong-link">
      <loginInput
        :label="$t('allDomain.commonFrequency')"
        inputStyle="width: 288px;"
        realInputStyle="width: 288px;"
        :inputValue="badReqOnSec"
        @changeInput="(e) => (badReqOnSec = e)"
      />
      <loginInput
        :label="$t('allDomain.BaseStationFrequency')"
        inputStyle="width: 288px; margin-left: 24px;"
        realInputStyle="width: 288px;"
        :inputValue="STBadReqOnSec"
        @changeInput="(e) => (STBadReqOnSec = e)"
      />
    </div>

    <div class="btn-commit" @click="commitClick">
      {{ $t("product.commit") }}
    </div>
    <!--  -->
  </div>
</template>

<script>
/* eslint-disable */
import {
  configCN,
  queryIPBalck,
  addIPBalck,
  delIPBalck,
  countryList,
  productDetail,
  productAddInterIP,
  productDeleteInterIP,
} from "@/service/requestRes";
export default {
  props: {
    domainHost: String,
    serverJson: String,
    pid: Number,
  },
  data() {
    return {
      product: null,
      remap_config_json: null,
      whiteip_config_json: null,
      blackip_config_json: null,      
      UserAgentText: "",
      matchUserAgentText: "",
      tableData: [],
      whiteTableData: [],
      blackTableData: [],
      isBanEmptyUA: -1,
      STBadReqOnSec: "",
      badReqOnSec: "",
      useCaptcha: null,
      jsGuard: false,
     banArea: false,
      banAsia: false,
      banAll: false,
      banOceania: false,
      banAfrica: false,
      banSouthAmeria: false,
      banEurope: false,
      banNorth: false,
      asiagroup: [],
      oceaniagroup: [],
      Africagroup: [],
      southAmeriagroup: [],
      europegroup: [],
      Northgroup: [],
      IPBalcktextarea: "",
      whiteurltextarea: "",
      UserAgentAction: 0,
      matchUserAgnet1: true,
      matchUserAgnet2: false,
      ipWhiteListItem: "",
      ipBlackListItem: '',
      countryList: [],
      checkboxGroup1: [],
      isEn_us: this.$i18n.locale == 'en_US',
    };
  },
  
  created() {
    this.isEn_us = this.$i18n.locale == 'en_US';
  },
  computed: {
    headerLables() {
      return [
        {
          label: `Ip/${this.$t('product.mark')}`,
          value: "IP",
        },
        {
          label: this.$t('product.handle'),
          value: "handle",
        },
      ];
    },
    items1() {
      return [
        {
          label: this.$t("product.onlyWarning"),
          value: 0,
        },
        {
          label: this.$t("product.InterceptOnly"),
          value: 1,
        },
        {
          label: this.$t("product.BlackList"),
          value: 3,
        }
        ];
    },
  },
  mounted() {
    // this.queryWhiteBlackList("white");
    // this.queryWhiteBlackList("black");
    this.getProductDetail();
    this.queryCountryList();
  },
  watch: {
    '$i18n.locale': function (e) {
      this.isEn_us = e == 'en_US';
    },
    remap_config_json (val) {
    let serverJson1 = {};
      try {
        serverJson1 = val && JSON.parse(val);
        const { security } = serverJson1 || {};
        const { 
          UserAgentAction, matchUserAgnet, 
          STBadReqOnSec, UserAgent, 
          badReqOnSec, banArea, 
          clearPath, isBanEmptyUA, 
          useCaptcha, blackurl, whiteurl,
          jsGuard, guardlevel
           } = security || {};
        this.UserAgentAction=UserAgentAction;
        if (banArea) {
          this.checkboxGroup1 = banArea;
          this.banArea = banArea.length !== 0;
        } else {
          this.checkboxGroup1 = [];
          this.banArea = false;
        }
        
        // matchUserAgnet && matchUserAgnet.forEach(item => {
        //   if (item == '2') {
        //     this.matchUserAgnet1 = true;
        //   }
        //   if (item == 3) {
        //     this.matchUserAgnet2 = true;
        //   }
        // });
        this.UserAgentText = UserAgent && UserAgent.join("\n");
        this.matchUserAgentText = matchUserAgnet && matchUserAgnet.join("\n");
        this.whiteurltextarea = whiteurl && whiteurl.join('\n');
        this.IPBalcktextarea = blackurl && blackurl.join('\n');
        this.isBanEmptyUA = isBanEmptyUA === 1;
        this.useCaptcha = useCaptcha === 1;
        this.jsGuard = guardlevel === 2;
        this.badReqOnSec = String(badReqOnSec);
        this.STBadReqOnSec = String(STBadReqOnSec);
      } catch(e) {
          console.error(e);
      }
    },
    whiteip_config_json (val) {
    let serverJson1 = [];
      try {
        serverJson1 = val && JSON.parse(val);
        this.whiteTableData = serverJson1;
      } catch(e) {
          console.error(e);
      }
    },
    blackip_config_json (val) {
    let serverJson1 = [];
      try {
        serverJson1 = val && JSON.parse(val);
        this.blackTableData = serverJson1;
      } catch(e) {
          console.error(e);
      }
    }
  },
  methods: {
    getProductDetail() {
      productDetail(
          this.pid
      ).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
            this.product = data;
            this.remap_config_json = this.product.remap_config_json;
            this.whiteip_config_json = this.product.whiteip_config_json;
            this.blackip_config_json = this.product.blackip_config_json;
        } else {
          this.$message({
            message: msg,
            type: 'error',
          });
        }
      });
    },
    queryCountryList() {
      countryList().then(res => {
        const { data, code, msg } = res || {};
          if (code === 1) {
            const { list } = data || {};
            this.countryList = list;
          }
      });
    },
    queryWhiteBlackList(type) {
      queryIPBalck({
        host: this.domainHost,
        type,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          if (type === "white") {
            this.whiteTableData = data;
          } else {
            this.blackTableData = data;
          }
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    addIPBlackWhite({ ip, type }) {
      productAddInterIP({
        ip,
        // host: this.domainHost,
        type,
        pid: this.product.id,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.getProductDetail();
          this.$message({
            message: this.$t('common.success'),
            type: "success",
          });
          this.ipWhiteListItem = '';
          this.ipBlackListItem = '';
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    configCNMethod(obj) {
      configCN({
        ...obj,
        // host: this.domainHost,
        pid: this.product.id,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
             this.$message({
            message: this.$t('common.success'),
            type: "success",
          });
          this.getProductDetail();
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
          this.getProductDetail();
          this.jsGuardReset();
        }
      });
    },
    addWhite() {
      if (!this.ipWhiteListItem) {
        this.$message({
          message: "请输入ip",
          type: "error",
        });
        return;
      }
      this.addIPBlackWhite({ ip: this.ipWhiteListItem, type: "white" });
    },
    addBlack() {
      if (!this.ipBlackListItem) {
        this.$message({
          message: "请输入ip",
          type: "error",
        });
        return;
      }
      this.addIPBlackWhite({ ip: this.ipBlackListItem, type: "black" });
    },
    selectedCheck1(e) {
      console.log(e);
    },
    selectedCheck2(e) {
      console.log(e);
    },
    selectedCheck3(e) {
      console.log(e);
    },
    switchChange(e) {
      console.log(e);
      if (e) {
        this.isBanEmptyUA = 1;
      } else {
        this.isBanEmptyUA = -1;
      }
    },
    delClick(item, type) {
      productDeleteInterIP({
        ip: item,
        pid: this.product.id,
        type,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.getProductDetail();
          this.$message({
            message: this.$t('common.success'),
            type: "success",
          });
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    commiturlArea() {
      const myGroup = this.asiagroup.concat(this.oceaniagroup).concat(this.Africagroup).concat(this.southAmeriagroup).concat(this.Northgroup).concat(this.europegroup);
    const banArea =  {
	"func": "banArea",
        host: this.domainHost,
    "security":{
    	"banArea_states":true,
        "banArea": myGroup
    }
    
}

       this.configCNMethod(banArea);
    },
    
    checkedAsiaClick(e, type) {
    this.checkboxGroup1 = [];
    
      if (type === 'Asia') {
        
      this.banAsia = e;
        if (e) {
        this.countryList && this.countryList.forEach(item => {
          if (type === item.continent) {
          this.asiagroup.push(item.cname);
          }
        });
      } else {
        this.asiagroup = [];
      }
      } else if (type === 'Oceania') {
        
      this.banOceania = e;
 if (e) {
        this.countryList && this.countryList.forEach(item => {
          if (type === item.continent) {
          this.oceaniagroup.push(item.cname);
          }
        });
      } else {
        this.oceaniagroup = [];
      }
      } else if (type === 'Africa') {
        
      this.banAfrica = e;
         if (e) {
        this.countryList && this.countryList.forEach(item => {
          if (type === item.continent) {
          this.Africagroup.push(item.cname);
          }
        });
      } else {
        this.Africagroup = [];
      }
      } else if (type === 'South America') {
        
      this.banSouthAmeria = e;
 if (e) {
        this.countryList && this.countryList.forEach(item => {
          if (type === item.continent) {
          this.southAmeriagroup.push(item.cname);
          }
        });
      } else {
        this.southAmeriagroup = [];
      }
      }
       else if (type === 'North America') {
        
      this.banNorth = e;
 if (e) {
        this.countryList && this.countryList.forEach(item => {
          if (type === item.continent) {
          this.Northgroup.push(item.cname);
          }
        });
      } else {
        this.Northgroup = [];
      }
      }
      else if (type === 'Europe') {
        
      this.banEurope = e;
         if (e) {
        this.countryList && this.countryList.forEach(item => {
          if (type === item.continent) {
          this.europegroup.push(item.cname);
          }
        });
      } else {
        this.europegroup = [];
      }
      }
      
      if (this.banAsia && this.banOceania && this.banAfrica && this.banSouthAmeria && this.banEurope && this.banNorth) {
        this.banAll = true;
      }
      this.checkboxGroup1 = this.asiagroup.concat(this.oceaniagroup).concat(this.Africagroup).concat(this.southAmeriagroup).concat(this.Northgroup).concat(this.europegroup);
   
    },
    
    checkedAllClick(e) {
      this.checkboxGroup1 = [];
      this.asiagroup = [];
      this.oceaniagroup = [];
      this.Africagroup = [];
      this.southAmeriagroup = [];
      this.europegroup = [];
      this.Northgroup = [];
      this.banAsia = e;
      this.banOceania = e;
      this.banAfrica = e;
      this.banSouthAmeria = e;
      this.banEurope = e;
      this.banNorth = e;
      this.banAll = true;
      if (e) {
        this.countryList && this.countryList.forEach(item => {
          // this.checkboxGroup1.push(item.cname);
           if (item.continent === 'Asia') {
             this.asiagroup.push(item.cname);
           } else if (item.continent === 'Oceania') {
this.oceaniagroup.push(item.cname);
           } else  if (item.continent === 'Africa') {
this.Africagroup.push(item.cname);
           } else if (item.continent === 'South America') {
this.southAmeriagroup.push(item.cname);
           }else if (item.continent === 'North America') {
this.Northgroup.push(item.cname);
           }
           
           else if (item.continent === 'Europe') {
this.europegroup.push(item.cname);
           }
        });
      }
       this.checkboxGroup1 = this.asiagroup.concat(this.oceaniagroup).concat(this.Africagroup).concat(this.southAmeriagroup).concat(this.Northgroup).concat(this.europegroup);
  
   },
    commitClick1() {
      //  const userA =
      //   (this.UserAgent &&
      //     this.UserAgent.split("|")) ||
      //   [];
      // // User-Agent
      // const arr = [];
      // if (this.matchUserAgnet1) {
      //   arr.push("2");
      // }
      // if (this.matchUserAgnet2) {
      //   arr.push("3");
      // }
      const userAgent = {
        func: "UserAgent",
        host: this.domainHost,
        security: {
          UserAgentAction: this.UserAgentAction,
          UserAgent: (this.UserAgentText && this.UserAgentText.split("\n")) || [],
          matchUserAgnet: (this.matchUserAgentText && this.matchUserAgentText.split("\n")) || [],
          isBanEmptyUA: this.isBanEmptyUA,
        },
      };
       this.configCNMethod(userAgent);
    },
    commiturlWhiteClick() {

      const whiteurl =
        (this.whiteurltextarea && this.whiteurltextarea.split("\n")) || [];
      // url白名单
      const urlWhite = {
        func: "whiteurl",
        host: this.domainHost,
        security: {
          whiteurl: whiteurl,
        },
      };

       this.configCNMethod(urlWhite);
    },
    commiturlBlackClick() {

      const blackurl =
        (this.IPBalcktextarea && this.IPBalcktextarea.split("\n")) || [];
      const urlBlack = {
        func: "blackurl",
        host: this.domainHost,
        security: {
          blackurl: blackurl,
        },
      };

       this.configCNMethod(urlBlack);
    },
    jsGuardChange(e) {
       // jsGuard防御
      const jsGuard = {
        func: "jsGuard",
        host: this.domainHost,
        security: {
          jsGuard: e ? 2 : 0,
        },
      };

       this.configCNMethod(jsGuard);
    },
    jsGuardReset(){
        this.$refs.jsguard.switch2 = this.jsGuard;
    },
    useCaptchaChange(e) {
      const yzmfy = {
        func: "useCaptcha",
        host: this.domainHost,
        security: {
          useCaptcha: e ? 1 : -1,
        },
      };
       this.configCNMethod(yzmfy);
    },
    commitClick() {
      const badReq = {
        func: "badReq",
        host: this.domainHost,
        security: {
          badReqOnSec: this.badReqOnSec,
          STBadReqOnSec: this.STBadReqOnSec,
        },
      };

      this.configCNMethod(badReq);
    },
  },
};
</script>

<style lang="scss" scoped>
.cenum-setting {
  padding: 21px 0;
  .cenue-title {
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #030503;
  }
  .lan-dong {
    margin-top: 18px;
    .checkbox-content {
      margin-top: 6px;
      display: flex;
      align-items: center;
    }
  }

  .margin-top {
    margin-top: -15px;
  }

  .btn-commit {
    // padding: 8px 44px;
    // margin: 24px 24px;
    padding-top: 8px;
    padding-bottom: 8px;
    width: 120px;
    background: #d9e4ff;
    border-radius: 4px;
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #1e5eff;
    cursor: pointer;
    text-align: center;
  }
  .row-line {
    display: flex;
    align-items: flex-end;
    margin-bottom: 36px;
    .new-add {
      padding: 8px 44px;
      width: 120px;
      height: 40px;
      background: #d9e4ff;
      border-radius: 4px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #1e5eff;
      cursor: pointer;
      margin-left: 10px;
      margin-bottom: 6px;
    }
  }
  .lan-dong-link {
    display: flex;
    margin-top: 24px;
  }
  .handle-first {
    cursor: pointer;
  }
}
.my-line {
  width: 100%;
  height: 3px;
  background-color: #1e5eff;
  margin: 48px 0 24px 0;
}

.tip-label {
  margin-bottom: 26px;
}
::v-deep .el-checkbox {
  width: 200px;
}

.checkout-rows {
  display: flex;
  width: 500px;
  align-items: center;
}
::v-deep .center-switch[data-v-48388d7e] {
  width: auto;
  padding: 0;
}

::v-deep .swiitch-content span[data-v-48388d7e] { 
 white-space: nowrap;
}

</style>
